var exports = {
  "k": "x52a3aa3b--e75cef--container",
  "Q": "x52a3aa3b--e75cef--container--desktop",
};

module.exports = exports;
